import Menu from './Compartido/Menu.jsx';
import TextoPropiedades from './Propiedades/TextoPropiedades.jsx';
import Footer from './Compartido/Footer.jsx';

const Propiedades = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextoPropiedades
                propiedades={props.textopropiedades}
                config={props.config}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Propiedades;
